var map = {
	"./black-paper.png": 87586,
	"./coworkr/favicons/icon.ico": 33969,
	"./coworkr/favicons/icon114.png": 46385,
	"./coworkr/favicons/icon120.png": 61152,
	"./coworkr/favicons/icon144.png": 2406,
	"./coworkr/favicons/icon150.png": 65300,
	"./coworkr/favicons/icon152.png": 56274,
	"./coworkr/favicons/icon310.png": 60377,
	"./coworkr/favicons/icon57.png": 74638,
	"./coworkr/favicons/icon70.png": 20462,
	"./coworkr/favicons/icon72.png": 83265,
	"./coworkr/favicons/icon76.png": 86488,
	"./coworkr/favicons/icon_final.png": 47794,
	"./coworkr/logo-with-favicon.png": 88536,
	"./de.svg": 37323,
	"./en-gb.svg": 64082,
	"./logo.png": 10270,
	"./logo_with_favicon.200.png": 22679,
	"./logo_with_favicon.png": 27159,
	"./mail/email.png": 76348,
	"./mail/facebook.png": 93096,
	"./mail/facebook_messenger.png": 3792,
	"./mail/linkedin.png": 26965,
	"./mail/native.png": 68298,
	"./mail/telegram.png": 61984,
	"./mail/whatsapp.png": 62223,
	"./mail/x-twitter.png": 8940,
	"./mail/xing.png": 58688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48999;